import ThirtyDaysCard from "./ThirtyDaysCard";
import Spinner from "../spinner/Spinner";
import LeaderBoardStyles from "./LeaderBoardStyles.module.css";
import {LeaderBoardThirtyDaysProps} from "../../types/ComponentProps";

const LeaderboardThirtyDaysList = ({
  leaderboardData,
  loadingLeaderboard,
}: LeaderBoardThirtyDaysProps) => {
  const leaderboard = leaderboardData?.showThirtyDaysLeaderboard ?? [];

  return (
    <div className={LeaderBoardStyles?.leaderboardListContainer}>
      {loadingLeaderboard ? (
        <Spinner alignSpin="center-spinner" variant="small-spinner" />
      ) : (
        leaderboard
          .slice(0, 5)
          .map((data) =>
              <ThirtyDaysCard key={data.user.id} data={data} />)
      )}
    </div>
  );
};

export default LeaderboardThirtyDaysList;
